@let selected = markers();
@if (selected.length) {
  <div data-test="kp-selected-row" class="flex items-start justify-between gap-4 border-b border-border px-8 py-5">
    <!-- A 16px line, like the chips, so the count sits on the first chip line. -->
    <span data-test="kp-selected-count" class="shrink-0 whitespace-nowrap text-sm leading-8 font-semibold text-gray-800">
      {{ selected.length }} selected
    </span>

    <!--
      Two lines of 16px chips at most, then the chips scroll between the count and Clear, which stay put. The
      chips scroll, so they take focus: a keyboard cannot scroll a region it cannot reach, and a connection chip
      has no button of its own (axe: scrollable-region-focusable).
    -->
    <div
      data-test="kp-selected-chips"
      class="flex max-h-[36px] min-w-0 flex-1 flex-wrap items-center gap-2 overflow-y-auto"
      tabindex="0"
      role="region"
      aria-label="Selected"
    >
      @for (marker of selected; track marker.key) {
        @switch (marker.kind) {
          @case ('knot') {
            <app-knot
              data-test="kp-selected-chip"
              class="min-w-0"
              [knot]="marker.item"
              [selected]="true"
              [withRemove]="true"
              [withControls]="false"
              [dragEnabled]="false"
              [dropEnabled]="false"
              (click)="keepUpTo($event, marker)"
              (onRemove)="remove(marker)"
            />
          }
          @case ('tag') {
            <app-tag
              data-test="kp-selected-chip"
              class="min-w-0"
              [tag]="marker.item"
              [selected]="true"
              [withRemove]="true"
              [withControls]="false"
              [dragEnabled]="false"
              [dropEnabled]="false"
              (click)="keepUpTo($event, marker)"
              (onRemove)="remove(marker)"
            />
          }
          @case ('connection') {
            <app-connection
              data-test="kp-selected-chip"
              class="min-w-0"
              [connection]="marker.item"
              [selected]="true"
              [withRemove]="true"
              [withControls]="false"
              [dragEnabled]="false"
              [dropEnabled]="false"
              (click)="keepUpTo($event, marker)"
              (onRemove)="remove(marker)"
            />
          }
          @case ('keyword') {
            <app-kp-keyword-chip
              data-test="kp-selected-keyword"
              class="min-w-0"
              [keyword]="marker.item.name"
              (remove)="remove(marker)"
            />
          }
        }
      }
    </div>

    <app-button2 data-test="kp-selected-clear" class="shrink-0" appearance="primary-text" size="s" (click)="clear()">
      Clear
    </app-button2>
  </div>
}
